module.exports = __webpack_public_path__ + "img/161-ee0d7e.png";